module.exports = __webpack_public_path__ + "img/menu-bar.5dae6aa3.png";